import React, { useEffect, useRef, useState } from "react";
import { Canvas, IText, Image } from "fabric";
import "./ImageEditor.css";
import {closePopup, openPopup} from "../../utils/CommonUtils";


const ImageEditor = ({ imageUrl, type, setFileList, setModifyFileList, onClose}) => {
  const canvasRef = useRef(null);
  const [canvas, setCanvas] = useState(null);
  const [selectedObject, setSelectedObject] = useState(null);

  useEffect(() => {
    const fabricCanvas = new Canvas(canvasRef.current, {
      width: 500,
      height: 500,
      backgroundColor: "#FFFFFF",
    });

    fabricCanvas.on('selection:created', (e) => {
      setSelectedObject(e.selected[0]);
    });

    fabricCanvas.on('selection:cleared', () => {
      setSelectedObject(null);
    });

    setCanvas(fabricCanvas);

    // 이미지 URL 로딩
    if (imageUrl) {
      const imgElement = new window.Image();
      imgElement.crossOrigin = 'Anonymous'; // CORS 이슈 방지
      /**
       * ! @deprecated
       * 개발 단계에서 멈춤
       * @author Saccharin01
       * @since 2026-04-17
       * @see 
       */
      const proxiedUrl = `/proxyApi/proxy?url=${encodeURIComponent(imageUrl)}`;
      imgElement.src = proxiedUrl;
      imgElement.onload = () => {
        const maxSize = 300;
        let width = imgElement.width;
        let height = imgElement.height;

        if (width > height && width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        } else if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }

        const fabricImage = new Image(imgElement, {
          left: 100,
          top: 100,
          scaleX: width / imgElement.width,
          scaleY: height / imgElement.height,
          selectable: true,
        });

        fabricCanvas.add(fabricImage);
        fabricCanvas.setActiveObject(fabricImage);
        setSelectedObject(fabricImage);
        fabricCanvas.renderAll();
      };
    }

    return () => {
      fabricCanvas.dispose();
    };
  }, [imageUrl]);

  // Delete 키로 오브젝트 삭제
  useEffect(() => {
    const deleteSelectedObject = () => {
      if (selectedObject && canvas) {
        canvas.remove(selectedObject);
        setSelectedObject(null);
        canvas.renderAll();
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Delete') {
        deleteSelectedObject();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedObject, canvas]);

  // 저장
  const saveImage = () => {
    if (!canvas) return;

    // 캔버스 일부 영역을 PNG로 base64 인코딩
    const dataUrl = canvas.toDataURL({
      format: 'png',
      quality: 1,
      left: 125.5,
      top: 125.5,
      width: 250,
      height: 250,
      multiplier: 1,
    });

    // base64를 이미지 객체로 변환 후 가공
    const image = new window.Image();
    image.src = dataUrl;

    let dataId = 0;
    if (type === 2) {
      const menuImgFile2 = document.getElementById("menuImgFile2");
      dataId = menuImgFile2.getAttribute("data-id");
    }

    image.onload = () => {
      const arr1 = 'canvas-image.png'.split(".");
      const arr2 = dataUrl.split(",");

      const size = Math.ceil((arr2[1].length * 3) / 4); // 대략적인 용량 계산 (base64 → byte)

      if (size <= 3072000) {
        // DOM 조작
        document.querySelector(`#menuImgPreview${type} .menuImg`).setAttribute("src", dataUrl);
        document.querySelector(`#menuImgPreview${type} .menuImg`).setAttribute("data-id", "0");
        document.querySelector(`#menuImgPreview${type} .imgBtn`).classList.add("hide");
        document.querySelector(`#menuImgPreview${type} .imageSearchBtn`).classList.add("hide");
        document.querySelector(`#menuImgPreview${type} .menuImgPreview`).classList.remove("hide");

        // 파일 객체 구성
        let fileImg;
        if (Number(dataId) !== 0) {
          fileImg = {
            menuImageId: Number(dataId),
            encodedFile: arr2[1],
            fileName: arr1[0] + '_9',
            fileExtension: arr1[1],
            imageType: 9
          };
          setModifyFileList(prev => [...prev, fileImg]);
        } else {
          fileImg = {
            encodedFile: arr2[1],
            fileName: arr1[0] + '_9',
            fileExtension: arr1[1],
            imageType: 9
          };
          setFileList(prev => [...prev, fileImg]);
        }
      } else {
        // 용량 초과 시 초기화
        setFileList([]);
        setModifyFileList([]);
      }

      // 로딩 숨기기
      document.querySelector(".lodding").classList.add("hide");
      // 부모 상태 초기화
      onClose?.();
      closePopup(`menuImageSearchPopup${type}`);
      closePopup("menuImageSearchPopup3");
    };
  };

  const previewImage = () => {
    if (!canvas) return;

    // 캔버스 일부 영역을 PNG로 base64 인코딩
    const dataUrl = canvas.toDataURL({
      format: 'png',
      quality: 1,
      left: 125.5,
      top: 125.5,
      width: 250,
      height: 250,
      multiplier: 1,
    });

    // base64를 이미지 객체로 변환 후 가공
    const image = new window.Image();
    image.src = dataUrl;

    image.onload = () => {
      document.querySelector(`.menuSearchPreview1 img`).setAttribute("src", dataUrl);
      document.querySelector(`.menuSearchPreview2 img`).setAttribute("src", dataUrl);
      openPopup("menuImageSearchPopup4");
    };
  };

  return (
    <>
      <div className="popupContent imageEditorBox">
        <div className="image-editor">
          <div className="canvas-container">
            <canvas ref={canvasRef} />
          </div>
          <button type="button" onClick={previewImage}>미리보기</button>
        </div>
      </div>
      <div className='popupBtn'>
        <button type='button' className='closeBtn stopCloseBtn' onClick={() => closePopup("menuImageSearchPopup3")}>취소</button>
        <button type='button' id="shopInfo1Btn" className='shopInfo1Btn blueBtn' onClick={saveImage}>이미지 저장</button>
      </div>
    </>
  );
};

export default ImageEditor;
